/**
 * @generated SignedSource<<01ac32c13d2dc617cef9e00d72275be2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type organizationpermission = "ADMIN" | "MEMBER" | "MODERATOR" | "REMOTE_PILOT" | "SKYDIO_READONLY" | "SKYDIO_SUPERUSER" | "TESTER" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useCurrentUser_user$data = {
  readonly id: string;
  readonly organizationId: string | null;
  readonly organizationPermission: organizationpermission;
  readonly " $fragmentSpreads": FragmentRefs<"useUserOverrides_user">;
  readonly " $fragmentType": "useCurrentUser_user";
};
export type useCurrentUser_user$key = {
  readonly " $data"?: useCurrentUser_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentUser_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentUser_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationPermission",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useUserOverrides_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bf3104a44d4bc1c39cde23d79531ee88";

export default node;
